import { useState } from 'react';
import { PaperAirplaneIcon } from '@heroicons/react/24/outline';
import {
    RESEND_TOOLTIP,
    RESEND_COOLDOWN_MESSAGE,
    RESEND_KEEP_LABEL,
    RESEND_CONFIRM_LABEL,
    buildResendQuestion,
    ACTION_BUTTON_CLASSES,
} from '../vacationRequestDetailsModal.definitions';

export interface ResendClientEmailActionProps {
    email: string;
    canResend: boolean;
    isResending: boolean;
    onConfirm: () => void;
}

export function ResendClientEmailAction({
    email,
    canResend,
    isResending,
    onConfirm,
}: ResendClientEmailActionProps) {
    const [isConfirming, setIsConfirming] = useState(false);

    if (!isConfirming) {
        return (
            <button
                type="button"
                onClick={() => setIsConfirming(true)}
                disabled={!canResend || isResending}
                title={canResend ? RESEND_TOOLTIP : RESEND_COOLDOWN_MESSAGE}
                aria-label={canResend ? RESEND_TOOLTIP : RESEND_COOLDOWN_MESSAGE}
                className="flex h-5 w-5 shrink-0 items-center justify-center rounded-lg text-gray-500 transition-colors hover:text-blue-600 disabled:cursor-not-allowed disabled:opacity-40"
            >
                <PaperAirplaneIcon className="h-4 w-4" aria-hidden="true" />
            </button>
        );
    }

    return (
        <div className="flex flex-col items-end gap-2 sm:flex-row sm:items-center">
            <p className={`text-gray-700 font-montserrat ${ACTION_BUTTON_CLASSES.compactWarning}`}>{buildResendQuestion(email)}</p>
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={() => setIsConfirming(false)}
                    disabled={isResending}
                    className={`rounded-xl border border-gray-200 bg-white font-semibold text-raro-gray-700 transition-colors hover:bg-gray-50 font-montserrat ${ACTION_BUTTON_CLASSES.compact}`}
                >
                    {RESEND_KEEP_LABEL}
                </button>
                <button
                    type="button"
                    onClick={onConfirm}
                    disabled={isResending}
                    className={`rounded-xl border border-transparent bg-blue-600 font-semibold text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60 font-montserrat ${ACTION_BUTTON_CLASSES.compact}`}
                >
                    {RESEND_CONFIRM_LABEL}
                </button>
            </div>
        </div>
    );
}

export default ResendClientEmailAction;
